async function Refresh(designid) {

    if (designid.length > 0) {

        let response;

        let params = JSON.stringify(
            {
                "designid": designid
            });

        response = await fetch("https://api.cssi.co/CNF/ResetDesign", {
            method: "POST",
            body: params
        })
            .then(response => {
                return response.json();
            })
            .catch(e => {
                e.name === "AbortError" ? console.log("Fetch Aborted") : console.log(e.message);
            })
        return Promise.resolve(response);
    }
}

export default Refresh;